import {useMappedState} from 'redux-react-hook'
import {convertList, sortList, convertType} from 'utils/convertData'
import {formatNumber} from 'utils/format'

function useOrderHistory (symbolInfo) {
  const mapState = state => ({
    data: state?.orders?.orderHistories || {},
    hasMore: state?.orders?.orderHistoriesHasMore
  })
  const {hasMore, data: orderHistoryEntity} = useMappedState(mapState)
  const orderHistories = Object.values(orderHistoryEntity)
  const {pricePrecision, quantityPrecision, lng} = symbolInfo

  return {
    hasMore,
    data: sortList(convertList(orderHistories))?.map(v => {
      const type = v.type?.toUpperCase()
      const status = v.status?.toUpperCase()
      const isBuy = v.side === 'BUY'
      const isMarket = type === 'MARKET'
      const isStop = type === 'STOP'
      const isProfit = type === 'TAKE_PROFIT'
      const stopPrice = v.stopPrice > 0 && (isStop || isProfit)
        ? `${(isStop && isBuy) || (isProfit && !isBuy) ? '>=' : '<='}${formatNumber(
          v.stopPrice,
          pricePrecision
        )}`
        : '-'
      return {
        ...v,
        type: convertType(lng, type),
        status: convertType(lng, status),
        side: (
          <span style={{color: isBuy ? '#00c582' : '#ff0371'}}>{convertType(lng, v.side)}</span>
        ),
        price: isMarket ? '-' : formatNumber(v.price, pricePrecision),
        avgPrice: formatNumber(v.avgPrice, pricePrecision),
        executedPrice: formatNumber(v.executedPrice, pricePrecision),
        executedQty: formatNumber(v.executedQty, quantityPrecision),
        origQty: formatNumber(v.origQty, quantityPrecision),
        stopPrice
      }
    })
  }
}

export default useOrderHistory
